import React from 'react';
import type ProjectSettingsServiceDeskIncidentManagementType from '@atlassian/jira-spa-apps-project-settings-service-desk-incident-management/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskIncidentManagement = lazyForPaint<
	typeof ProjectSettingsServiceDeskIncidentManagementType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-incident-management", jiraSpaEntry: "async-project-settings-service-desk-incident-management" */ '@atlassian/jira-spa-apps-project-settings-service-desk-incident-management'
		),
	),
);

const AsyncProjectSettingsServiceDeskIncidentManagement = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskIncidentManagement}
		pageId="project-settings-incident-management"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskIncidentManagement;
